/* import __COLOCATED_TEMPLATE__ from './tasks-card.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';

export default class TasksCard extends Component {
  get appLinkColorBg() {
    return `background-color: ${this.args.configuration.appColors.link_color};`;
  }
}
